import { Box } from "@mui/material";
import "./_style.scss";
import logo from "../../../assets/images/logo.png";
import EmailIcon from "@mui/icons-material/Email";
import FaxIcon from "@mui/icons-material/Fax";
import WifiCalling3Icon from "@mui/icons-material/WifiCalling3";
import { TkFooterProps } from "../../../type/componentsType/TkFooter";
import authorityUserType from "../../../assets/data/TkAuthorityProperty";
/**
 * フッター部品
 * ＜共済契約者＞または＜法人代行者＞向けと＜退職者＞向けの２種類それぞれ定義
 * ＜機構＞向け＜社会福祉協議会＞向け画面には表示しない
 * @param {TkFooterProps} props - TkFooterコンポーネントのprops
 * @param userType : ユーザータイプ
 * @returns TkFotter
 */
export const TkFooter: React.FC<TkFooterProps> = (props) => {
  const { userType, pagePath } = props;

  return (
    <>
      {pagePath === "/SCRC030001" ||
      pagePath === "/error" ||
      userType === authorityUserType.userTypeNumber.KEIYAKUSYA ||
      userType === authorityUserType.userTypeNumber.DAIKOSHA ||
      userType === authorityUserType.userTypeNumber.TAISYOKUSYA ? (
        <Box data-testid="tkFooterForTest" className="tkFooter">
          <Box className="logo">
            <img src={logo} alt="logo" />
          </Box>
          <Box className="context">
            <Box className="footerinfo">
              <Box>
                <EmailIcon color="primary" />
                <a
                  href="https://www.wam.go.jp/hp/info-tabid-640/info-kyousai01-tabid-2093/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  お問い合わせフォーム
                </a>
              </Box>

              <Box>
                <FaxIcon color="primary" />
                Fax: 03-3438-0584・03-3438-9261
              </Box>

              <Box>
                <WifiCalling3Icon color="primary" />
                Tel: 0570-050-294
              </Box>
            </Box>
            {userType === authorityUserType.userTypeNumber.TAISYOKUSYA ? (
              <Box>
                <a
                  className="LinkName"
                  href="https://www.wam.go.jp/hp/cat/taisyokuteate/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  福祉医療機構ホームページ（退職手当共済事業）
                </a>
              </Box>
            ) : (
              <Box className="text">
                お問い合わせの際は、「共済契約者番号」をご用意ください。
              </Box>
            )}
          </Box>
          <Box className="logo logoHide"></Box>
        </Box>
      ) : (
        <></>
      )}
    </>
  );
};

export default TkFooter;
